import React, { createContext, useContext, useState } from "react";

const PGIModeContext = createContext();

export const usePGIMode = () => useContext(PGIModeContext);
export function ContextPGIMode({ children }) {
  const [mode, setMode] = useState(false);

  const handleChangeMode = (value) => {
    setMode(value);
  };

  const collection = {
    mode,
    handleChangeMode,
  };
  return (
    <PGIModeContext.Provider value={collection}>
      {children}
    </PGIModeContext.Provider>
  );
}
